import { render, staticRenderFns } from "./AppraisalGraph.vue?vue&type=template&id=635fcb7e"
import script from "./AppraisalGraph.vue?vue&type=script&lang=ts"
export * from "./AppraisalGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports